'use client';

import Archive from '../../../src/routes/Archive';

export default function ArchiveClient() {
  return <Archive />;
}
